module.exports = __webpack_public_path__ + "img/36.8.TSS.b71ee77c.png";